import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const IndustriesSocial = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('reveal-show'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className="business-hero" style={{ background: 'linear-gradient(135deg, #065f46, #10b981)' }}>
        <div className="hero-content">
          <h1 className="hero-title reveal-text">Social Impact</h1>
          <p className="hero-subtitle reveal-text delay-1">Making a difference through charitable initiatives and community development</p>
        </div>
      </div>
      <div className="business-wrapper">
        <div className="container">
          <div className="category">
            <div className="category-header green"><h2>Our Foundation</h2><p>Driving positive change in education, healthcare, and communities</p></div>
            <div className="card-grid">
              <div className="business-card green reveal-card"><h3>AALI TRUSTZ</h3><p>Charitable foundation dedicated to education, healthcare, and community development initiatives</p><Link to="/companies/aalitrustz">Know More →</Link></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IndustriesSocial;